import * as types from "./types";

export const getScripts = (payload) => ({
  type: types.GET_SCRIPTS.request,
  payload,
});
export const getScriptsAdmin = (payload) => ({
  type: types.GET_SCRIPTS_ADMIN.request,
  payload,
});

// this is for the pagination
export const changeScriptPage = (payload) => ({
  type: types.CHANGE_PAGE.request,
  payload,
});

export const getScript = (payload) => ({
  type: types.GET_SCRIPT.request,
  payload,
});
export const getUserInfoScript = (payload) => ({
  type: types.CURRENT_USER_INFO_SCRIPT.request,
  payload,
});

export const deleteScript = (payload) => ({
  type: types.DELETE_SCRIPT.request,
  payload,
});
export const verifyScript = (payload) => ({
  type: types.VERIFY_SCRIPT.request,
  payload,
});

export const myScripts = () => ({
  type: types.MY_SCRIPTS.request,
});
export const singleScript = () => ({
  type: types.MY_SCRIPTS.request,
});
export const searchScript = (payload) => ({
  type: types.SEARCH_SCRIPT.request,
  payload,
});
export const searchResult = (payload) => ({
  type: types.SEARCH_RESULT.request,
  payload,
});
export const rateScript = (payload) => ({
  type: types.RATE_SCRIPT.request,
  payload,
});

export const addFavourite = (payload) => ({
  type: types.ADD_FAVOURITE.request,
  payload,
});

export const removeFavorite = (payload) => ({
  type: types.REMOVE_FAVOURITE.request,
  payload,
});

export const followUser = (payload) => ({
  type: types.FOLLOW_USER.request,
  payload,
});

export const unfollowAUser = (payload) => ({
  type: types.UNFOLLOW_USER.request,
  payload,
});
export const editScript = (payload) => ({
  type: "EDIT_SCRIPT",
  payload,
});
export const editScriptAPI = (payload) => ({
  type: types.EDIT_SCRIPT.request,
  payload,
});
export const updateScriptMedia = (payload) => ({
  type: types.UPDATE_SCRIPT_MEDIA.request,
  payload,
});
export const getComposers = () => ({
  type: types.GET_ALL_COMPOSERS.request,
});
export const editComposers = (payload) => ({
  type: "EDIT_COMPOSER",
  payload,
});
